export default __webpack_public_path__ + "static/media/4_BarrelOfGems.0bf50b75.png";